


















































































































































































































import { Component, Vue } from 'vue-property-decorator'

@Component
class TransportError extends Vue {}

export default TransportError
